module.exports = __webpack_public_path__ + "static/media/manu2.992b5bf8.png";